/**
 * 用户信息
 */
import {
  NOW_THEME_COLOR,
  NOW_UP_COLOR,
  NOW_LANG,
  ACTIVE_PAGE,
  ACTIVESYMBOL,
  AGENTCONFIG
} from "../mutation-type";

let lang = navigator.language;

const state = {
  mainColor: "white", // 当前主题色
  contentColor: "red", // 当前显示的红涨绿跌
  lang:
    (localStorage.getItem("lang") || navigator.language).includes("zh") ||
    (localStorage.getItem("lang") || navigator.language).includes("cn")
      ? "cn"
      : "en", // 当前语言
  activePage: "home",
  activeSymbolItem: {}, // 当前合约
  agentConfig:{},
  ...(localStorage.getItem("ddtrader.state")
    ? JSON.parse(localStorage.getItem("ddtrader.state")).home
    : {}),
};

const mutations = {
  [NOW_THEME_COLOR]: (s, mainColor) => {
    s.mainColor = mainColor;
  },
  [NOW_UP_COLOR]: (s, contentColor) => {
    s.contentColor = contentColor;
  },
  [NOW_LANG]: (s, lang) => {
    s.lang = lang;
    console.log("lang=======", lang);
    localStorage.setItem("lang", lang); // 更新 localStorage
  },
  [ACTIVE_PAGE]: (s, activePage) => {
    s.activePage = activePage;
  },
  [ACTIVESYMBOL]: (s, activeSymbol) => {
    Object.assign(s.activeSymbolItem, activeSymbol);
  },
  [AGENTCONFIG]: (s, agentConfig) => {
    Object.assign(s.agentConfig, agentConfig);
  },
};

export default {
  state,
  mutations,
};
